import React, { Component } from "react";
import ReactDOM from 'react-dom';
import {
    Input
} from "reactstrap";


class TYSelect extends Component{
    constructor(props){
        super(props);

        this.state = {
            item: null,
            listShown: false,
            showOtherField: false,
            otherValue: ""
        };

        this.inputClicked = this.inputClicked.bind(this);
        this.itemClicked = this.itemClicked.bind(this);
        this.otherClicked = this.otherClicked.bind(this);
        this.otherValueChanged = this.otherValueChanged.bind(this);
        this.handleDocClick = this.handleDocClick.bind(this);
    }

    componentWillMount() {
        document.addEventListener('click', this.handleDocClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocClick, false);
    }

    handleDocClick(e){
        if(!ReactDOM.findDOMNode(this).contains(e.target)) {
            if(this.state.listShown)
                this.setState({listShown: false});
        }
    }

    inputClicked(){
        this.setState({
            listShown: !this.state.listShown
        });
    }

    itemClicked(item){
        this.setState({
            item: item,
            listShown: !this.state.listShown
        });
        this.props.itemClicked(item);
    }

    otherClicked(){
        this.setState({showOtherField: true, otherValue: ""});
    }

    otherValueChanged(e){
        let v = e.target.value;
        this.setState({otherValue: v});
        this.props.onOtherValueChanged(v);
    }

    render(){
        let items_list = [];
        let i = 0;
        let selected_value = false;

        while(i < this.props.items.length){
            let s = this.props.items[i];
            if(this.props.isSelected(this.props.selected, s))
                selected_value = this.props.renderItem(s);

            items_list.push(
                <li key={i} className={this.props.itemClass}
                    onClick={() => { this.itemClicked(s) }}>
                    {this.props.renderItem(s)}
                </li>
            );

            i++;
        }

        let showOther = this.state.showOtherField;
        if(!selected_value && this.props.otherActive && this.props.selected)
            showOther = true;

        if(showOther)
            return <Input
                className="wp-100"
                onChange={this.otherValueChanged}
                value={this.state.otherValue || (this.state.showOtherField ? "" : this.props.selected)}
                placeholder={this.props.otherPlaceholder} />;

        return (
            <div className={"relative " + this.props.className}>
                <div
                    className={ this.props.inputClass + (!this.state.item ? " " + this.props.placeholderColor: "") + " pointer" }
                    onClick={ this.inputClicked }
                >
                    { !this.state.item ? (selected_value ? selected_value : this.props.placeholder) : this.props.renderItem(this.state.item) }

                    <i className={"icon icon-chevron-"+(this.state.listShown ? "up" : "down")+" absolute right-10 top-20"} aria-hidden="true"> </i>
                </div>
                {
                    this.state.listShown && (this.props.items.length || this.props.footer || this.props.otherActive) ?

                        <ul className={this.props.listClass} style={{
                            zIndex: 10000, overflow: "scroll"
                        }}>
                            {items_list.map(item => {return item})}
                            {
                                this.props.otherActive ?
                                <li className={this.props.itemClass}
                                    onClick={this.otherClicked}>
                                    Autre ...
                                </li>
                                : ""
                            }
                            {
                                this.props.footer ?
                                <li className={this.props.itemClass}
                                    onClick={this.props.onFooterClicked}>
                                    {this.props.footer}
                                </li>
                                : ""
                            }
                        </ul>

                        : ""
                }
            </div>
        );
    }
}

TYSelect.defaultProps = {
    selected: false,
    className: "",
    placeholder: "Choisir ...",
    otherPlaceholder: "...",
    placeholderColor: "grey_dark",
    inputClass: "wp-100 border-rad-5 f-14 border-1-gray pad-15 bg-white blue_dark",
    itemClass: "pad-10 ty-item-select-border-b-1-gray f-12 blue_dark blue-hover pointer",
    listClass: "wp-100 list-unstyled bg-white absolute top-50 border-1-gray ty-select-suggestion-height",
    itemClicked: suggest => {},
    renderItem: item => { return item; },
    onFooterClicked: () => {},
    onOtherValueChanged: value => {},
    isSelected: (selected, item) => { return item === selected; },
    items: [],
    footer: false,
    otherActive: false
};

export default TYSelect;



// WEBPACK FOOTER //
// ./src/components/TYSelect.js